import {useEffect, useState} from 'react'
import {useRouter} from 'next/router'
import {About, BodySections, HeroSection, Newsletter} from 'modules/home'
import {addApolloState, initializeApollo} from 'helpers/ApolloHelper/ApolloHelper'
import Page from '_app/components/Page/Page'
import {Context} from '_app/types/context'
import {useHomePage} from 'modules/home/hooks/useHomePage'
import withAppInit from '_app/hoc/withAppInit'
import {EdroneEvents} from '_app/utils/edrone'
import MagicLoader from '../components/atoms/MagicLoader/MagicLoader'
import I18nHelper from '../helpers/I18nHelper/I18nHelper'
import SeoHelper from '../helpers/SeoHelper/SeoHelper'
import TrustBanner from '../components/molecules/TrustBanner/TrustBanner'
import DialogHomePage from '../components/atoms/DialogHomePage/DialogHomePage'
import LocalStorageHelper from '../helpers/LocalStorageHelper/LocalStorageHelper'
import {APP_ROUTES} from '../_app/routes'
import RequestEnum from '../enums/RequestEnum/RequestEnum'
import {GET_HOME_PAGE} from '../_app/graphql/cms/queries/GetHomePage'
import BannerPromotion from '../components/molecules/BannerPromotion/BannerPromotion'
import BreakpointsHelper from '../helpers/BreakpointsHelper/BreakpointsHelper'

const Index = ({hasNoIndex, hasNoFollow }: any) => {
    const router = useRouter()
    const {locale} = router
    const apolloClient = initializeApollo(null, {})
    const [cms, setCms] = useState({})
    const [loading, setLoading] = useState(true)
    const {
        hero,
        opinions,
        newsletter,
        sections,
        mobileVideoUrl,
        mobileVideoCopy,
    } = useHomePage(cms)
    const handleCms = async () => {
        // const {data: tempDAta}: any = await apolloClient.query({
        //     query: GET_HOME_PAGE,
        //     variables: {
        //         locale,
        //     },
        //     context: {
        //         clientName: RequestEnum.CMS_PUBLIC,
        //     },
        // })
        const data: any = {
            'homePage': {
                'data': {
                    'id': '3',
                    '__typename': 'HomePageEntity',
                    'attributes': {
                        'hero': [
                            {
                                'id': '184',
                                'title': 'Talizman dla Mamy',
                                'description': null,
                                'color': '#fefcfe',
                                'bg': 'transparent',
                                'alignment': 'start',
                                'cta': {
                                    'id': '287',
                                    'text': 'Odkryj',
                                    'link': {
                                        'id': '1370',
                                        'external_href': null,
                                        'target': 'self',
                                        'text': null,
                                        'href': '/inspiracje/dzien-mamy',
                                        'rel': null,
                                        '__typename': 'ComponentPartsLink'
                                    },
                                    'variant': 'solid',
                                    'reversed': true,
                                    '__typename': 'ComponentPartsCta'
                                },
                                'link': null,
                                'img': {
                                    'data': {
                                        'id': '3897',
                                        'attributes': {
                                            'alternativeText': null,
                                            'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/bff8cef3-4af2-40e6-0b6b-4aa198d04800/public',
                                            'width': 1920,
                                            'height': 820,
                                            '__typename': 'UploadFile'
                                        },
                                        '__typename': 'UploadFileEntity'
                                    },
                                    '__typename': 'UploadFileEntityResponse'
                                },
                                'img_mobile': {
                                    'data': {
                                        'id': '3898',
                                        'attributes': {
                                            'alternativeText': null,
                                            'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/4a6329d9-418b-48a9-f15b-544c27acdd00/public',
                                            'width': 1080,
                                            'height': 1613,
                                            '__typename': 'UploadFile'
                                        },
                                        '__typename': 'UploadFileEntity'
                                    },
                                    '__typename': 'UploadFileEntityResponse'
                                },
                                'variant': null,
                                'section_title': 'Talizman dla Mamy',
                                '__typename': 'ComponentSectionsBanner'
                            },
                            {
                                'id': '183',
                                'title': 'Apaszka Kraina Szczęścia',
                                'description': null,
                                'color': '#ffffff',
                                'bg': 'transparent',
                                'alignment': 'start',
                                'cta': {
                                    'id': '286',
                                    'text': 'Odkryj',
                                    'link': {
                                        'id': '1369',
                                        'external_href': null,
                                        'target': 'self',
                                        'text': null,
                                        'href': '/apaszka-kraina-szczescia',
                                        'rel': null,
                                        '__typename': 'ComponentPartsLink'
                                    },
                                    'variant': 'solid',
                                    'reversed': true,
                                    '__typename': 'ComponentPartsCta'
                                },
                                'link': null,
                                'img': {
                                    'data': {
                                        'id': '3909',
                                        'attributes': {
                                            'alternativeText': null,
                                            'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/fa732481-6d09-4c9b-72bb-e8def03e3300/public',
                                            'width': 1920,
                                            'height': 820,
                                            '__typename': 'UploadFile'
                                        },
                                        '__typename': 'UploadFileEntity'
                                    },
                                    '__typename': 'UploadFileEntityResponse'
                                },
                                'img_mobile': {
                                    'data': {
                                        'id': '3896',
                                        'attributes': {
                                            'alternativeText': null,
                                            'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/45828e16-e5a4-4ed5-e596-bbf175bbb900/public',
                                            'width': 1080,
                                            'height': 1613,
                                            '__typename': 'UploadFile'
                                        },
                                        '__typename': 'UploadFileEntity'
                                    },
                                    '__typename': 'UploadFileEntityResponse'
                                },
                                'variant': null,
                                'section_title': 'Kolekcja Koral',
                                '__typename': 'ComponentSectionsBanner'
                            },
                            {
                                'id': '183',
                                'title': 'Kolekcja Koral',
                                'description': null,
                                'color': '#ffffff',
                                'bg': 'transparent',
                                'alignment': 'start',
                                'cta': {
                                    'id': '286',
                                    'text': 'Odkryj',
                                    'link': {
                                        'id': '1369',
                                        'external_href': null,
                                        'target': 'self',
                                        'text': null,
                                        'href': '/sklep/kolekcje/kolekcja-koral',
                                        'rel': null,
                                        '__typename': 'ComponentPartsLink'
                                    },
                                    'variant': 'solid',
                                    'reversed': true,
                                    '__typename': 'ComponentPartsCta'
                                },
                                'link': null,
                                'img': {
                                    'data': {
                                        'id': '3909',
                                        'attributes': {
                                            'alternativeText': null,
                                            'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/947876b8-2f31-4eeb-8903-6caceaa6cb00/public',
                                            'width': 1920,
                                            'height': 820,
                                            '__typename': 'UploadFile'
                                        },
                                        '__typename': 'UploadFileEntity'
                                    },
                                    '__typename': 'UploadFileEntityResponse'
                                },
                                'img_mobile': {
                                    'data': {
                                        'id': '3896',
                                        'attributes': {
                                            'alternativeText': null,
                                            'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/fbc0290c-d66e-4bbc-862f-43cb69508c00/public',
                                            'width': 1080,
                                            'height': 1613,
                                            '__typename': 'UploadFile'
                                        },
                                        '__typename': 'UploadFileEntity'
                                    },
                                    '__typename': 'UploadFileEntityResponse'
                                },
                                'variant': null,
                                'section_title': 'Kolekcja Koral',
                                '__typename': 'ComponentSectionsBanner'
                            },
                        ],
                        'sections': [
                            {
                                '__typename': 'ComponentSectionsGrid',
                                'id': '1',
                                'section_title': '',
                                'items': [
                                    {
                                        'id': '1',
                                        'title': 'Bransoletki damskie',
                                        'link': {
                                            'id': '122',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/bizuteria/bransoletki',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3899',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/2bfcbf32-232f-4238-fb85-9a28bef80500/public',
                                                    'width': 689,
                                                    'height': 689,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '4',
                                        'title': 'Naszyjniki damskie',
                                        'link': {
                                            'id': '124',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/bizuteria/naszyjniki',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3900',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/b651dd71-4cc6-444e-e9de-2829a12aa100/public',
                                                    'width': 330,
                                                    'height': 330,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '3',
                                        'title': 'Kolczyki damskie',
                                        'link': {
                                            'id': '120',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/bizuteria/kolczyki',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3794',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/bd0ead42-5b3c-446a-e005-1a8b0aedcc00/public',
                                                    'width': 330,
                                                    'height': 330,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '2',
                                        'title': 'Pierścionki damskie',
                                        'link': {
                                            'id': '121',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/bizuteria/pierscionki',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3901',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/da1c899d-e956-493e-bce3-739c7ad6a900/public',
                                                    'width': 330,
                                                    'height': 330,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '5',
                                        'title': 'Uczucia wyraź grawerunkiem',
                                        'link': {
                                            'id': '123',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/inspiracje/grawerunek',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3815',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/743f1a52-b335-4da2-5bef-fae1b9414e00/public',
                                                    'width': 330,
                                                    'height': 330,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    }
                                ]
                            },
                            {
                                '__typename': 'ComponentSectionsProductsList',
                                'id': '1925',
                                'section_title': 'Nowości',
                                'rows': 1
                            },
                            {
                                '__typename': 'ComponentSectionsSlider',
                                'id': '1',
                                'items': [
                                    {
                                        'id': '104',
                                        'title': 'Biżuteria męska',
                                        'description': '',
                                        'color': '#ffffff',
                                        'bg': 'transparent',
                                        'alignment': 'start',
                                        'cta': {
                                            'id': '191',
                                            'text': 'Zobacz',
                                            'link': {
                                                'id': '658',
                                                'external_href': null,
                                                'target': 'blank',
                                                'text': null,
                                                'href': '/sklep/bizuteria-meska',
                                                'rel': null,
                                                '__typename': 'ComponentPartsLink'
                                            },
                                            'variant': 'solid',
                                            'reversed': true,
                                            '__typename': 'ComponentPartsCta'
                                        },
                                        'link': null,
                                        'img': {
                                            'data': {
                                                'id': '3903',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/a37a65c5-0ff7-44aa-b08e-8ac34ed20900/public',
                                                    'width': 1920,
                                                    'height': 740,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        'img_mobile': {
                                            'data': {
                                                'id': '3902',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/b1c15a7c-ba2c-42bc-12b9-b4af928b1400/public',
                                                    'width': 920,
                                                    'height': 920,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        'variant': null,
                                        'section_title': 'Biżuteria męska',
                                        '__typename': 'ComponentSectionsBanner'
                                    }
                                ]
                            },
                            {
                                '__typename': 'ComponentSectionsProductsList',
                                'id': '1926',
                                'section_title': 'Bestsellery',
                                'rows': 1
                            },
                            {
                                '__typename': 'ComponentSectionsGrid',
                                'id': '2',
                                'section_title': 'Zainspiruj się',
                                'items': [
                                    {
                                        'id': '154',
                                        'title': 'Biżuteria na Chrzest i Komunię',
                                        'link': {
                                            'id': '1027',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/bizuteria/chrzest-i-komunia-sw',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3904',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/ecb13086-6e75-4862-e06e-e8b119281500/public',
                                                    'width': 689,
                                                    'height': 689,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '150',
                                        'title': 'Ślubne inspiracje',
                                        'link': {
                                            'id': '1023',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/inspiracje/bizuteria-dla-panny-mlodej',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3869',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/43c26405-969e-4117-48e3-4f407dade400/public',
                                                    'width': 1200,
                                                    'height': 1200,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '151',
                                        'title': 'Ikony Lilou',
                                        'link': {
                                            'id': '1024',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/polecane/inspiracje/ikony-lilou',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3906',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/48095006-1f50-432c-83a5-2896df926a00/public',
                                                    'width': 689,
                                                    'height': 689,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '153',
                                        'title': 'Akcesoria',
                                        'link': {
                                            'id': '1026',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/torebki-i-akcesoria',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3820',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/1b544112-ea22-4c67-1a29-96c1de5cc200/public',
                                                    'width': 689,
                                                    'height': 689,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                    {
                                        'id': '151',
                                        'title': 'Twój talizman szczęścia',
                                        'link': {
                                            'id': '1024',
                                            'external_href': null,
                                            'target': 'self',
                                            'text': null,
                                            'href': '/sklep/polecane/inspiracje/twoj-talizman-szczescia',
                                            'rel': null,
                                            '__typename': 'ComponentPartsLink'
                                        },
                                        'img': {
                                            'data': {
                                                'id': '3906',
                                                'attributes': {
                                                    'alternativeText': null,
                                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/c39bb782-3df5-488d-66c4-45001ec7ff00/public',
                                                    'width': 689,
                                                    'height': 689,
                                                    '__typename': 'UploadFile'
                                                },
                                                '__typename': 'UploadFileEntity'
                                            },
                                            '__typename': 'UploadFileEntityResponse'
                                        },
                                        '__typename': 'ComponentPartsGridItem'
                                    },
                                ]
                            }
                        ],
                        'opinions': {
                            'id': '9',
                            'items': [],
                            '__typename': 'ComponentSpecialOpinionsSlider'
                        },
                        'video_mobile': null,
                        '__typename': 'HomePage'
                    }
                },
                '__typename': 'HomePageEntityResponse'
            },
            'newsletterBanner': {
                'data': {
                    'attributes': {
                        'title': 'Subskrybuj Nasz Newsletter!',
                        'description': 'Bądź na bieżąco z nowościami i ofertami specjalnymi',
                        'header': 'Dołącz do newslettera',
                        'content': 'Dowiedz się więcej o najnowszych kolekcjach, trendach i akcjach specjalnych Lilou.',
                        'terms_and_conditions': 'Podając swój adres email i klikając DOŁĄCZ akceptujesz Regulamin usługi Newsletter.Administratorem Twoich danych osobowych jest grupa firm LILOU (1.LILOU Sp. z o.o. ul. Filtrowa 50, 02-032 Warszawa, Sąd Rejonowy dla m.st. Warszawy w Warszawie, XII Wydział Gospodarczy. KRS: 0000346352, NIP: 7010216745, kapitał zakładowy 5.000,00 zł; 2.LILOU RETAIL Sp. z o.o. Sp. k., ul. Filtrowa 50, 02-032 Warszawa, KRS 0000346352, REGON 142020870, NIP 7010216745; 3.LILOU ONLINE SHOP Sp. z o.o., Sp. k. ul. Filtrowej 50, 02-032 Warszawa, Sąd Rejonowy dla m.st. Warszaw w Warszawie, XII Wydział Gospodarczy, KRS: 0000663850, REGON: 366571012, NIP: 7010666632). Szczegółowe informacje na temat przetwarzania danych oraz przysługujących Ci prawach znajdziesz w Polityce Prywatności.',
                        'submit_btn': 'DOŁĄCZ',
                        'header_2': 'Dziękujemy za zapisanie na nasz newsletter!',
                        'content_2': 'Na podany adres e-mail została wysłana prośba o potwierdzenie subskrypcji.',
                        'close_btn': 'Zamknij',
                        'cta': {
                            'id': '151',
                            'text': 'DOŁĄCZ',
                            'link': {
                                'id': '1313',
                                'external_href': 'https://lilou.pl/information/newsletter',
                                'target': 'self',
                                'text': null,
                                'href': null,
                                'rel': null,
                                '__typename': 'ComponentPartsLink'
                            },
                            'variant': 'solid',
                            'reversed': true,
                            '__typename': 'ComponentPartsCta'
                        },
                        'img': {
                            'data': {
                                'id': '3918',
                                'attributes': {
                                    'alternativeText': null,
                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/d31f2ab2-08d9-4f99-ee4e-8488bf1fdc00/public',
                                    'width': 1835,
                                    'height': 401,
                                    '__typename': 'UploadFile'
                                },
                                '__typename': 'UploadFileEntity'
                            },
                            '__typename': 'UploadFileEntityResponse'
                        },
                        'img_2': {
                            'data': {
                                'id': '30',
                                'attributes': {
                                    'alternativeText': 'newsletter.jpg',
                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/2eaf747d-469a-4c9e-2f37-b3eb35e24f00/public',
                                    'width': 1200,
                                    'height': 1160,
                                    '__typename': 'UploadFile'
                                },
                                '__typename': 'UploadFileEntity'
                            },
                            '__typename': 'UploadFileEntityResponse'
                        },
                        'img_mobile': {
                            'data': {
                                'id': '3907',
                                'attributes': {
                                    'alternativeText': null,
                                    'url': 'https://imagedelivery.net/YUhTm7roalNqH3L4i_CXLg/558f0fa4-aae4-4ca9-f750-572836257800/public',
                                    'width': 384,
                                    'height': 504,
                                    '__typename': 'UploadFile'
                                },
                                '__typename': 'UploadFileEntity'
                            },
                            '__typename': 'UploadFileEntityResponse'
                        },
                        '__typename': 'NewsletterBanner'
                    },
                    '__typename': 'NewsletterBannerEntity'
                },
                '__typename': 'NewsletterBannerEntityResponse'
            }
        }
        setCms(data)
    }
    const [open, setOpen]: any = useState(false)
    const handleClose = () => {
        LocalStorageHelper.set('open', 'false')
        setOpen(false)
    }
    useEffect(() => {
        if (locale) {
            EdroneEvents.other(locale)
        }
    }, [locale])
    useEffect(() => {
        handleCms().then(() => {})
    }, [])
    useEffect(() => {
        if (cms) {
            setLoading(false)
        }
    }, [cms, hasNoIndex, hasNoFollow])
    return (
        <MagicLoader loadingOutSide={loading}>
            <Page
                isNavBarTransparent
                seo={{
                    title: SeoHelper.getTitle(),
                    description: SeoHelper.getDescription(),
                    openGraph: {
                        images: [{url: hero[0]?.img?.data?.attributes?.url ?? ''}],
                    },
                }}
                hasNoIndex={hasNoIndex}
                hasNoFollow={hasNoFollow}
            >
                {hero?.length ? <HeroSection hero={hero}/> : ''}
                {
                    locale === 'pl' ? (
                        <BannerPromotion
                            link={'/pl/inspiracje/dzien-mamy.html'}
                            background={'#f8b6c2'}
                            startDate={'2025-05-23 00:01'}
                            endDate={'2025-05-26 23:59'}
                            title={'Celebruj Dzień Mamy z Lilou. Do  końca akcji pozostało:'}
                            subTitle={'Odbierz prezent do zakupów od 479 zł'}
                        />
                    ) : ''
                }
                {
                    locale === 'de' ? (
                        <TrustBanner />
                    ) : ''
                }
                <BodySections
                    sections={sections}
                    mobileVideoUrl={mobileVideoUrl}
                    mobileVideoCopy={mobileVideoCopy}
                />
                {opinions?.length ? <About slides={opinions}/> : ''}
                {newsletter && <Newsletter {...newsletter} />}
                {
                    open && (
                        <DialogHomePage
                            onClose={() => handleClose()}
                        />
                    )
                }
            </Page>
        </MagicLoader>
    )
}

export const getStaticProps = withAppInit(async (ctx: Context) => {
    return addApolloState(ctx.apolloClient, {
        props: {
            ...(await I18nHelper.getI18nProps(ctx, ['engraving'])),
        },
    })
}, true)

export default Index
